import type {
  NotificationApi,
  NotificationsListQuery,
  UpdateNotificationStatusQuery,
} from "@/Modules/Models/Api/ActivityCenter";

import type { PaginatedApiResponse } from "@/Modules/App/Models/Api/PaginatedApiResponse";

import TherapySideApiService from "@/Services/TherapyApi/utils/TherapyApi";

class ActivityCenterApiConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  getNotificationsList(
    notificationsListQuery: NotificationsListQuery
  ): Promise<PaginatedApiResponse<NotificationApi>> {
    return this.ApiService.get<NotificationsListQuery, PaginatedApiResponse<NotificationApi>>({
      endpoint: "v1.0/activity-center",
      params: notificationsListQuery,
      responseParams: { raw: true },
    });
  }

  async updateNotifications(updateNotificationsStatusQuery: UpdateNotificationStatusQuery[]) {
    return this.ApiService.patch<UpdateNotificationStatusQuery[], void>({
      endpoint: "v1.0/activity-center",
      body: updateNotificationsStatusQuery,
    });
  }
}

export default ActivityCenterApiConnector;
